import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {Moment} from 'moment';
import {MultiSelectFilter} from '../../../../../shared/components/multi-select-component';
import {ReportsService} from '../../../../../data/reports/reports.service';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { ResultId } from '../../../../../shared/components/pass-fail-filter/pass-fail-filter.component';


@Component({
  selector: 'app-dvir-report-preview',
  templateUrl: './dvir-report-preview.component.html',
  styles: ['.iframe { border: 0; width: 800px; height: calc(90vh - 73px); }', '.frame { overflow-y: hidden; overflow-x: auto; }'],
  imports: [MatDialogActions, MatButton, MatDialogClose, MatDivider],
})
export class DvirReportPreviewDialogComponent implements OnInit {
  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DvirReportPreviewDialogComponent>,
    private reportsService: ReportsService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      vehicleId: number;
      from: Moment;
      to: Moment;
      vehicleGroupFilter: MultiSelectFilter<number>;
      passFailFilter: string;
    }
  ) {}

  ngOnInit(): void {
    this.reportsService.getDvirHtml(
      this.data.vehicleId,
      this.data.from,
      this.data.to,
      !!this.data.vehicleGroupFilter && !!this.data.vehicleGroupFilter.elements ? this.data.vehicleGroupFilter : null,
      this.data.passFailFilter === ResultId.PASS ? true : (this.data.passFailFilter === ResultId.FAIL ? false : null),
    ).then(blob => {
      this.iframe.nativeElement.src = URL.createObjectURL(blob);
    });
  }
}
